export const QUERY_DELAY = 200;
export const QUERY_DELAY_EXTENDED = 1000;
export const QUERY_DEBOUNCE_OPTS = { maxWait: 1000 };
